import { getEnv } from '../../../config/env'

const REACT_APP_WP_URL = getEnv('REACT_APP_WP_URL')

export const DASHBOARD_ITEMS = [
  // TODO: Replace literals for ids inside i18n and add formatMessage to father
  {
    title: 'Servicio de Nedgia',
    subtitle: 'Lectura de contador',
    description: 'Gestiona la lectura del contador',
    linkLabel: 'Pulsa aquí',
    linkTo: '/',
  },
  {
    title: 'Servicio de Nedgia',
    subtitle: '¿Quieres gas en tu domicilio?',
    description: 'Inicia el viaje de cliente',
    linkLabel: 'Pulsa aquí',
    linkTo: '/',
  },
]

export const CLIENT_JOURNEY_LINK = REACT_APP_WP_URL
